import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from '@/context/AppContext';
import { ConfirmDialogProvider } from '@/components/shared/ConfirmDialog';
import AppShell from '@/components/layout/AppShell';
import Landing from '@/pages/Landing';
import CommandCenter from '@/pages/CommandCenter';
import Portfolios from '@/pages/Portfolios';
import Assignments from '@/pages/Assignments';
import AgentWorkspace from '@/pages/AgentWorkspace';
import Debtor360 from '@/pages/Debtor360';
import SupervisorCockpit from '@/pages/SupervisorCockpit';
import LegalWorkbench from '@/pages/LegalWorkbench';
import Compliance from '@/pages/Compliance';
import IntegrationHub from '@/pages/IntegrationHub';
import AuditLogs from '@/pages/AuditLogs';
import DebtorPortal from '@/pages/DebtorPortal';
import VoiceDashboard from '@/pages/voice/VoiceDashboard';
import AgentLibrary from '@/pages/voice/AgentLibrary';
import CreateAgent from '@/pages/voice/CreateAgent';
import ConversationDesigner from '@/pages/voice/ConversationDesigner';
import CampaignAssignment from '@/pages/voice/CampaignAssignment';
import TestSimulator from '@/pages/voice/TestSimulator';
import CallReview from '@/pages/voice/CallReview';
import VoiceAnalytics from '@/pages/voice/VoiceAnalytics';
import VoiceCompliance from '@/pages/voice/VoiceCompliance';
import VoicesLibrary from '@/pages/voice/VoicesLibrary';
import VoiceIntegrations from '@/pages/voice/VoiceIntegrations';

export default function App() {
  return (
    <AppProvider>
      <ConfirmDialogProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/portal" element={<DebtorPortal />} />
            <Route path="/app" element={<AppShell />}>
              <Route index element={<Navigate to="/app/command-center" replace />} />
              <Route path="command-center" element={<CommandCenter />} />
              <Route path="portfolios" element={<Portfolios />} />
              <Route path="assignments" element={<Assignments />} />
              <Route path="agent" element={<AgentWorkspace />} />
              <Route path="agent/case/:caseId" element={<Debtor360 />} />
              <Route path="supervisor" element={<SupervisorCockpit />} />
              <Route path="legal" element={<LegalWorkbench />} />
              <Route path="compliance" element={<Compliance />} />
              <Route path="integrations" element={<IntegrationHub />} />
              <Route path="audit" element={<AuditLogs />} />
              <Route path="voice-agents" element={<VoiceDashboard />} />
              <Route path="voice-agents/library" element={<AgentLibrary />} />
              <Route path="voice-agents/create" element={<CreateAgent />} />
              <Route path="voice-agents/designer" element={<ConversationDesigner />} />
              <Route path="voice-agents/campaigns" element={<CampaignAssignment />} />
              <Route path="voice-agents/simulator" element={<TestSimulator />} />
              <Route path="voice-agents/review" element={<CallReview />} />
              <Route path="voice-agents/analytics" element={<VoiceAnalytics />} />
              <Route path="voice-agents/compliance" element={<VoiceCompliance />} />
              <Route path="voice-agents/voices" element={<VoicesLibrary />} />
              <Route path="voice-agents/integrations" element={<VoiceIntegrations />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ConfirmDialogProvider>
    </AppProvider>
  );
}
